import { render } from "./ModalErrorAcceso.vue?vue&type=template&id=1d41274d"
import script from "./ModalErrorAcceso.vue?vue&type=script&lang=js"
export * from "./ModalErrorAcceso.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__